import axios from "../axios";
import { PaymentDataResponse } from "../types/paymentLink";

export const getPaymentLinkData = async (linkId?: string): Promise<PaymentDataResponse> => {
  try {
    const response = await axios.get(`api/payment/link/${linkId}`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch payment link data");
  }
};

export const submitPaymentLinkData = async ({
  linkId,
  data,
}: {
  linkId?: string;
  data: Record<string, string>;
}): Promise<PaymentDataResponse> => {
  try {
    const response = await axios.post(`api/payment/link/${linkId}/transaction`, data);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " | Failed to submit payment link data");
  }
};
